import DefaultRenderer from './Default'
import store from '../../store'
import { qs, qsa } from '../../utils'
import Swiper, { Navigation, Pagination, EffectFade, Autoplay } from 'swiper'
import 'swiper/swiper-bundle.css'
Swiper.use([Navigation, Pagination, EffectFade, Autoplay])

class CommunityRenderer extends DefaultRenderer {
  constructor(opts) {
    super(opts)
  }

  initRender() {
    store.resizeFn = null
    store.section = 'community'

    this.onPageChange()
    this.setUpVideo()
  }

  onEnter() {
    super.onEnter()
  }

  onLeave() {
    super.onLeave()
  }

  onEnterCompleted() {
    super.onEnterCompleted()
    this.initRender()
  }

  onLeaveCompleted() {
    super.onLeaveCompleted()
  }

  setUpVideo() {
    const $parent = qsa('.video-mask')
    $parent.forEach(($mask) => {
      const $iframe = qs('iframe', $mask)
      const $trigger = qs('img', $mask)

      $trigger.addEventListener('click', () => {
        $iframe.src += '?autoplay=1&showinfo=0&controls=1&disablekb=1'
        $mask.classList.add('active')
      })
      const $svg = qs('.play', $mask)
      $svg.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          $iframe.src += '?autoplay=1&showinfo=0&controls=1&disablekb=1'
          $mask.classList.add('active')
        }
      })
    })
  }
}

export default CommunityRenderer
